import { render, staticRenderFns } from "./WikiSearch.vue?vue&type=template&id=d43765e4&"
import script from "./WikiSearch.vue?vue&type=script&lang=js&"
export * from "./WikiSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports